import React, {useContext, useMemo} from 'react';
import {PlayerContext} from "../../../shared/contexts/playerContext";
import dayjs from "dayjs";
import LogTemplate from "../../logs/LogTemplate";
import {getEventTruckLogColumns} from "../../logs/columns/eventTruckLogColumns";

const PlayerEventTruckLog = () => {
    const { playerData } = useContext(PlayerContext);

    const defaultSearchParams = {
        begin: dayjs().subtract(3, 'month').startOf('day').unix(),
        end: dayjs().endOf('day').unix(),
        pid: playerData.pid,
        logType: 'RQEventTruckLog',
        isUnix: true
    };

    const columns = useMemo(() => getEventTruckLogColumns(), []);

    return (
        <div>
            <LogTemplate
                columns={columns}
                defaultSearchParams={defaultSearchParams}
                routerUrl={'/logs/operation'}
                logName={'EventTruckLog'}
                log={'operation'}
            />
        </div>
    );
};

export default PlayerEventTruckLog;